import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=3f245215&scoped=true"
import script from "./UserFilter.vue?vue&type=script&lang=js"
export * from "./UserFilter.vue?vue&type=script&lang=js"
import style0 from "./UserFilter.vue?vue&type=style&index=0&id=3f245215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f245215",
  null
  
)

export default component.exports